export default "__VITE_ASSET__10061a81__"